import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { CreateAccount } from 'common/schema/*'

import { axiosInstance } from '../../../axiosInstance'
import { Button, TextInput, RichTextInput } from '../../../components'

import { toast } from 'react-toastify'

export function AccountsCreate() {
  const navigate = useNavigate()

  const formik = useFormik({
    initialValues: {
      organization_name: '',
      resources: '',
    },
    validationSchema: CreateAccount.schema(),
    onSubmit: (values) => handleSubmit(values),
  })

  const [richTextValue, setRichTextValue] = useState('')

  useEffect(() => {
    formik.setFieldValue('resources', richTextValue)
  }, [richTextValue])

  async function handleSubmit(values) {
    await axiosInstance
      .post('accounts/create', values)
      .then(() => {
        toast.success('Account created successfully!')
        navigate('/admin/accounts')
      })
      .catch((err) => toast.error(`Error: ${err.response.data}`))
  }

  return (
    <div>
      <div className="admin_form_page">
        <h1>Add Account</h1>
        <form className="admin_form" onSubmit={formik.handleSubmit}>
          <TextInput
            label="Organization Name"
            name="organization_name"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            hasErrors={formik.touched.organization_name && formik.errors.organization_name}
            errorMessage={formik.errors.organization_name}
          />
          <RichTextInput label="Resources" id="resources" value={richTextValue} onChange={setRichTextValue} />
          <div className="submit_container">
            <Button type="submit" text="Save" variant="primary" disabled={formik.isSubmitting} />
          </div>
        </form>
      </div>
    </div>
  )
}
